<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="eSB"
            description="Indicadores de Saúde Bucal na APS"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/p/h/8cj1fp4-2631/2fc51123cde0aa5/8cj1fp4-3631"
            pageIdentifier="indicadores-esb"
            :enableBadgeModalInformacao="
              Number($store.state.permissoesRaw?.indicadores_esb_ajuda || 0) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.indicadores_esb_ajuda || 0
            "
            keyAjudaModalInformacao="indicadores_esb_ajuda"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <span
                v-if="$store.getters.getQuantidadeAjuda(item.key) > 0"
                class="item-badge"
              >
                {{ $store.getters.getQuantidadeAjuda(item.key) }}
              </span>

              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import PrimeiraConsultaProgramada from '@/components/icons/IndicadoresEsb/Estrategicos/PrimeiraConsultaProgramada'
import TratamentosConcluidos from '@/components/icons/IndicadoresEsb/Estrategicos/TratamentosConcluidos'
import Exodontias from '@/components/icons/IndicadoresEsb/Estrategicos/Exodontias'
import EscovacaoSupervisionada from '@/components/icons/IndicadoresEsb/Estrategicos/EscovacaoSupervisionada'
import Prevencao from '@/components/icons/IndicadoresEsb/Ampliados/Prevencao'
import TratamentosRestauradoresArt from '@/components/icons/IndicadoresEsb/Ampliados/TratamentosRestauradoresArt'
import ConsultasPreNatal from '@/components/icons/IndicadoresAps/PreNatal/ConsultasPreNatal.vue'

export default {
  name: 'SaudeBucal',
  metaInfo: {
    title: 'eSB',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    PrimeiraConsultaProgramada,
    TratamentosConcluidos,
    Exodontias,
    EscovacaoSupervisionada,
    Prevencao,
    TratamentosRestauradoresArt,
    ConsultasPreNatal,
  },
  async mounted() {
    await this.carregarProcedimentosIndicadores()
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.indicadores_esb
      ) {
        const dataClone = [...this.$store.state.permissoes.indicadores_esb]
        return dataClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  data() {
    return {}
  },
  methods: {
    /**
     * Carrega os procedimentos dos indicadores APS.
     *
     * Busca os códigos CIAP, CID e SIGTAP uma única vez e salva na store
     * separados por indicador, numerador e denominador.
     */
    async carregarProcedimentosIndicadores() {
      if (this.$store.state.procedimentosIndicadoresApsCarregados) return

      const response = await this.$api.post(
        `/app/utils/cids-ciaps-sigtap/${this.$store.state.cod_ibge}`,
        {
          ciap: ['NA'],
          cid: ['NA'],
          sigtap: ['DN_PREVENTIVOS_ODONTO', 'DN_EXODONTIA', 'DN_TRA_ART'],
        }
      )

      const lista = response.data || []

      const procedimentos = {
        exodontia: {
          numerador: [],
          denominador: [],
        },
        preventivosOdonto: {
          numerador: [],
          denominador: [],
        },
        traArt: {
          numerador: [],
          denominador: [],
        },
      }

      lista.forEach((item) => {
        // Ignora procedimentos ABPO
        if (item.codigo?.startsWith('ABPO')) return

        const registro = {
          icon: null,
          codigo: item.codigo,
          desc: item.nome,
        }

        let grupo = null

        if (item.id_grupo === 'DN_PREVENTIVOS_ODONTO') {
          grupo = procedimentos.preventivosOdonto
        }

        if (item.id_grupo === 'DN_EXODONTIA') {
          grupo = procedimentos.exodontia
        }

        if (item.id_grupo === 'DN_TRA_ART') {
          grupo = procedimentos.traArt
        }

        if (!grupo) return

        if (Number(item.numerador) === 1) {
          grupo.numerador.push(registro)
        }

        grupo.denominador.push(registro)
      })

      this.$store.commit('setProcedimentosIndicadoresAps', procedimentos)
    },
  },
}
</script>

<style></style>
